import { notifyError } from '../../../services/ToastifyService/ToastifyService'
import { CustomFileType } from '../../SingleRequestPage/components/SingleRequestDrawer/content/DrawerContentInstallation'
import { singleServiceStore } from '../stores/SingleServiceRequestStore'

export const getDeleteFileFn = (
  files: CustomFileType[] | null,
  setFiles: (value: React.SetStateAction<CustomFileType[] | null>) => void,
) => {
  return (file: CustomFileType) => {
    if (!files) {
      return
    }

    const updatedFiles = files?.filter((f) => f.url !== file.url)

    if (!updatedFiles.length) {
      setFiles(null)
    } else {
      setFiles(updatedFiles)
    }
  }
}

export const getHandleSetFiles = (
  intl: any,
  photoSettings: any,
  files: CustomFileType[] | null,
  setFiles: (value: React.SetStateAction<CustomFileType[] | null>) => void,
) => {
  return (newFiles: FileList) => {
    const updatedFiles: CustomFileType[] = files ? [...files] : []

    for (let fileNumber in newFiles) {
      const isTooManyPics =
        updatedFiles?.length >= photoSettings?.maxLimitPerLoad

      if (isTooManyPics || fileNumber === 'length') {
        return
      } else {
        if (newFiles[fileNumber].size > photoSettings?.maxImageSizeInBytes) {
          notifyError(
            `${intl.formatMessage(
              {
                id: 'Размер файла превышает {size} мегабайт',
                defaultMessage: 'Размер файла превышает {size} мегабайт',
              },
              {
                size: photoSettings?.maxImageSizeInBytes / 1000000,
              },
            )}: ${newFiles[fileNumber].name}`,
          )
        } else {
          updatedFiles.push({
            file: newFiles[fileNumber],
            url: URL.createObjectURL(newFiles[fileNumber]),
          })

          setFiles(updatedFiles)
        }
      }
    }
  }
}

export const getSettingField = (mode: 'to-rework' | 'to-impossible') => {
  switch (mode) {
    case 'to-impossible':
      return 'MaintenanceImpossible'
    case 'to-rework':
      return 'ImprovementRequired'
    default:
      return null
  }
}

export const onSuccessRework = (
  res: any,
  invalidate: (keysArr: string[]) => void,
  reset?: () => void,
) => {
  const imageError = imageDuplicateErrorHandler(res)

  if (imageError) return

  singleServiceStore.setIsOpen(false)
  invalidate([
    'get-service-history',
    'get-single-service-request',
    'get-service-images',
    'get-service-comments',
    'service-table',
  ])
  reset?.()

  return res
}

export const imageDuplicateErrorHandler = (
  res: any,
  withoutError?: boolean,
) => {
  const errorFileNames = []

  res?.images?.forEach((item: any) => {
    if (item.error === 'Дубликат') {
      !withoutError && notifyError(`Дубликат: ${item.filename}`)
      errorFileNames.push(item.filename)
    }
  })

  return !!errorFileNames.length
}
